import React, { useEffect, useState } from 'react';
import api from '../api';

const StatCard = ({ icon, label, value, sub, delay }) => (
  <div className="fade-up" style={{
    background: '#fff', borderRadius: 16, padding: '20px 22px',
    border: '1px solid var(--border)', animationDelay: delay,
    transition: 'transform 0.2s, box-shadow 0.2s',
  }}
    onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.08)'; }}
    onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
  >
    <div style={{ fontSize: 26, marginBottom: 10 }}>{icon}</div>
    <div style={{ fontSize: 11, color: 'var(--stone)', textTransform: 'uppercase', letterSpacing: '1.5px', fontWeight: 500 }}>
      {label}
    </div>
    <div style={{ fontFamily: "'Fraunces', serif", fontSize: 32, fontWeight: 400, color: 'var(--ink)', marginTop: 4 }}>
      {value}
    </div>
    {sub && <div style={{ fontSize: 12, color: 'var(--stone)', marginTop: 4, fontWeight: 300 }}>{sub}</div>}
  </div>
);

export default function DashboardPage() {
  const [stats, setStats]     = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admin/stats')
      .then(r => setStats(r.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh', color: 'var(--stone)' }}>
      Завантаження...
    </div>
  );

  return (
    <div>
      <div style={{ marginBottom: 28 }}>
        <div style={{ fontFamily: "'Fraunces', serif", fontSize: 28, fontWeight: 400 }}>Дашборд</div>
        <div style={{ fontSize: 13, color: 'var(--stone)', marginTop: 4, fontWeight: 300 }}>
          Огляд за сьогодні
        </div>
      </div>

      {/* Stats grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 14, marginBottom: 28 }}>
        <StatCard icon="🧾" label="Замовлень сьогодні" value={stats?.orders_today ?? 0} delay="0s" />
        <StatCard icon="💰" label="Виручка сьогодні"   value={`${stats?.revenue_today ?? 0} ₴`} delay="0.06s" />
        <StatCard icon="👥" label="Клієнтів"            value={stats?.total_users ?? 0} sub="всього зареєстровано" delay="0.12s" />
        <StatCard icon="🍽" label="Топ страва"
          value={stats?.top_dishes?.[0]?.emoji + ' ' + (stats?.top_dishes?.[0]?.name?.split(' ')[0] ?? '—')}
          sub={`${stats?.top_dishes?.[0]?.total_qty ?? 0} замовлень`}
          delay="0.18s"
        />
      </div>

      {/* Top dishes */}
      <div style={{ background: '#fff', borderRadius: 16, border: '1px solid var(--border)', padding: '20px 24px' }}>
        <div style={{ fontFamily: "'Fraunces', serif", fontSize: 18, marginBottom: 16 }}>Топ страви</div>
        {stats?.top_dishes?.length ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {stats.top_dishes.map((d, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{
                  width: 28, height: 28, borderRadius: '50%',
                  background: i === 0 ? 'var(--highlight)' : 'var(--sand2)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 12, fontWeight: 600, color: 'var(--ink)',
                }}>{i + 1}</div>
                <div style={{ fontSize: 20 }}>{d.emoji}</div>
                <div style={{ flex: 1, fontSize: 14, fontWeight: 400 }}>{d.name}</div>
                <div style={{
                  background: 'var(--success2)', color: 'var(--success)',
                  fontSize: 12, fontWeight: 500, padding: '3px 10px', borderRadius: 20,
                }}>{d.total_qty} шт</div>
              </div>
            ))}
          </div>
        ) : (
          <div style={{ color: 'var(--stone)', fontSize: 13 }}>Поки немає замовлень</div>
        )}
      </div>
    </div>
  );
}
